export const DragNode = ({ data }) => {
  return <div style={{ ...data.style }}>{data.label}</div>;
};
